import { Component } from "@angular/core";
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";

@Component({
    selector: "wk-taxprep-notes-panel",
    imports: [TranslateModule, JumpstartComponentsModule, ReactiveFormsModule],
    templateUrl: "./taxprep-notes-panel.component.html",
    styleUrl: "./taxprep-notes-panel.component.scss",
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class TaxprepNotesPanelComponent {}
